import React, { type FC } from 'react';
import {
  UiStack,
  uiStyles,
  type UiStackProps, UiText, UiHStack, UiIconInfo, UiIconListMagnifyingGlass,
} from '@/lib/ui';
import BaseDividerHorizontal from '@/base/Divider/Horizontal';

export interface InfoBoxProps extends UiStackProps {
  title?: string
  description?: string
}

const InfoBox: FC<InfoBoxProps> = ({
  title,
  description,
  ...props
}) => {
  if (!title && !description) {
    return null;
  }

  return (
    <UiStack spacing={0}>
      {/*<UiStack height={'100%'} width={2} bgColor={'primary.200'} borderRadius={uiStyles.borderRadius}/>*/}
      <UiStack
        // bgColor={'blackAlpha.50'}
        // px={{base: 4, lg: 6}}
        py={{base: 4, lg: 4}}
        // borderRadius={uiStyles.borderRadius}
        // spacing={1}
        // borderColor={'primary.100'}
        // borderWidth={'1px'}
        // borderStyle={'solid'}
        borderBottomStyle={'solid'}
        borderBottomWidth={'1px'}
        borderBottomColor={'gray.300'}
        whiteSpace={'break-spaces'}
        // pb={4}
        {...props}
      >
        <UiHStack>
          <UiIconInfo color={'green.400'} size={'3xl'}/>
          <UiText variant={'title'} fontWeight={600}>
            {title}
          </UiText>
        </UiHStack>
        {!!description && (
          <UiText variant={'body1'} color={'text.secondary'}>
            {description}
          </UiText>
        )}
      </UiStack>
      {/*<BaseDividerHorizontal height={{base: 2, lg: 4}}/>*/}
    </UiStack>
  );

  // return (
  //   <UiHStack
  //     bgColor={'whiteAlpha.600'}
  //     // borderRightRadius={uiStyles.borderRadius}
  //     spacing={0}
  //   >
  //     <UiStack
  //       width={'4px'}
  //       // borderRadius={uiStyles.borderRadius}
  //       bgColor={'gray.500'}
  //       height={'100%'}
  //     />
  //     <UiStack
  //       // bgColor={'whiteAlpha.600'}
  //       px={{base: 6, lg: 8}}
  //       py={{base: 4, lg: 6}}
  //       // borderRightRadius={uiStyles.borderRadius}
  //       spacing={1}
  //       // borderLeftStyle={'solid'}
  //       // borderLeftWidth={'2px'}
  //       // borderLeftColor={'gray.500'}
  //       // pb={4}
  //       {...props}
  //     >
  //       <UiText variant={'title'} fontWeight={600}>
  //         {title}
  //       </UiText>
  //       {!!description && (
  //         <UiText variant={'body1'} color={'text.secondary'}>
  //           {description}
  //         </UiText>
  //       )}
  //     </UiStack>
  //   </UiHStack>
  // );
};

export default InfoBox;
